const primaryPhone = `+966920031566`;
export const contact = {
  /** use this number for any support needed to handle order for both customers and carriers
   *
   * Available `WhatsApp` & `Calling`
   */
  orderSupportPhone: primaryPhone,

  /** general customer care for both customers and carriers.
   *
   * Available `WhatsApp` & `Calling`
   */
  customerCarePhone: primaryPhone,

  /** general customer care for both customers and carriers */
  customerCareEmail: 'info@tryhero.io',

  /** a general info email */
  infoEmail: 'info@tryhero.io',

  /** an email for the finance department */
  finEmail: 'fin@tryhero.io',

  /** an email for the sales department */
  salesEmail: 'sales@tryhero.io',

  /** an email for the operation department */
  operationsEmail: 'operations@tryhero.io',

  ordersEmail: 'order@tryhero.io',
} as const;
